import {Directive, ViewContainerRef} from '@angular/core';

@Directive({
    selector: '[message-host]',
})
export class BotatoChatMessageDirective {
    constructor(public viewContainerRef: ViewContainerRef) {
    }
}
